import React from "react"
import LoanCommissionForm from "./Form"
import ManageLoanCommission from './ManageItem'

export default function LoanCommission({ params }) {

  return <ManageLoanCommission
    params={ params }
    callback={ data => <LoanCommissionForm loanCommission={ data } /> }
  />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanCommission/Update.js